(ns practitest.frontend.signup.subs
  (:require [re-frame.core :as re-frame]))

(def default-time-zone "UTC")

;; Generic accessor, shared by the edit-signup and new-signup pages (never mounted together).
;; (subscribe [::signup k default])
(re-frame/reg-sub ::signup                       (fn [db [_ k default]] (get-in db [:signup k] default)))

(re-frame/reg-sub ::password-complexity-pattern  (fn [db _] (get-in db [:options :password-complexity-pattern])))
